import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from './Actions.jsx';
import tracking from '../../tracking/tracking.js';
import common from '../common/common';
import addressSearchConfig from '../../components/AddressSearch/config';
import { getSuggestionResultLength } from '../../utils/suggestionsUtils';
import { setSearchParams } from '../../utils/urlUtils.js';
import { getRealEstateType, getUserIntent } from '../../selectors/selectors.js';
import { PROPERTY_BOOK } from "../../tracking/trackingNaming";

const reportLabels = {
  addresses: 'index_search_selectaddress',
  districts: 'index_search_selectdistrict',
  cities: 'index_search_selectcity',
  regions: 'index_search_selectregion',
};

export class AddressSearchResults extends React.Component {
  static getHighlightedText(text, highlight) {
    // Split on highlight term and include term into parts, ignore case
    const parts = text.split(new RegExp(`(${common.escapeRegExp(highlight)})`, 'gi'));
    return parts.map((part, i) => (
      <span key={i} className={part.toLowerCase() === highlight.toLowerCase() ? 'suggestion-query' : ''}>
        {part}
      </span>
    ));
  }

  handleClick = (url, label) => (event) => {
    event.preventDefault();
    this.props.cancelSearch();
    this.trackAndNavigate(url, label);
  };

  trackAndNavigate = (url, label) => {
    tracking.report(label, PROPERTY_BOOK).then(() => {
      window.location.assign(url);
    });
  };

  generateLink = (url) => {
    const q0 = window.location.search;
    const q1 = setSearchParams('searchQuery', encodeURIComponent(this.props.suggestionQuery), q0);
    const q2 = setSearchParams('marketingFocus', encodeURIComponent(this.props.realEstateType), q1);
    const q3 = setSearchParams('userIntent', encodeURIComponent(this.props.userIntent), q2);
    const newUrl = url.replace(/\?.*/, '').replace(/#.*/, '');
    return `${newUrl}${q3}`;
  };

  renderSuggestionLink = (suggestionResult, index, selectedSuggestionIndex, reportLabel) => {
    const address = suggestionResult.address;
    const link = this.generateLink(suggestionResult.url);
    const suggestionText = address
      ? `${address.street} ${address.houseNumber}${
        address.houseNumberExtension ? ` ${address.houseNumberExtension}` : ''
      }, ${address.zipcode} ${address.city}`
      : suggestionResult.name
        ? suggestionResult.name
        : `${suggestionResult.name}`
          ? suggestionResult.name
          : `${suggestionResult.name}`
            ? suggestionResult.name
            : '';
    const selectedClass = index === selectedSuggestionIndex ? 'selected' : '';

    return (
      <div className="suggestion-result" key={link}>
        <a href={link} className={selectedClass} onMouseDown={this.handleClick(link, reportLabel)}>
          {AddressSearchResults.getHighlightedText(suggestionText, this.props.suggestionQuery)}
        </a>
      </div>
    );
  };

  renderSuggestionResultItems = (configItem, offset) => {
    const selectedIndex = this.props.selectedSuggestionIndex % getSuggestionResultLength(this.props.suggestionResults);
    const values = this.props.suggestionResults[configItem];
    const config = addressSearchConfig[configItem];
    const reportLabel = `${reportLabels[configItem]}_${this.props.userIntent.toLowerCase()}`;

    return (
      <div className="suggestion-result-block" key={configItem}>
        <span className="title">{config.title}</span>
        {values.map((value, index) => this.renderSuggestionLink(value, index + offset, selectedIndex, reportLabel))}
      </div>
    );
  };

  render() {
    let offset = 0;
    const suggestionResults = this.props.suggestionResults;

    if (getSuggestionResultLength(suggestionResults) <= 0) {
      return <div />;
    }

    return (
      <div
        id="suggestions"
        className="grid desk-three-fifths lap-three-fifths palm-one-whole desk-push-one-fifth lap-push-one-fifth"
      >
        {Object.keys(addressSearchConfig).map((configItem) => {
          if (suggestionResults[configItem].length > 0) {
            const suggestionResultHtml = this.renderSuggestionResultItems(configItem, offset);
            offset += (suggestionResults[configItem] || []).length;
            return suggestionResultHtml;
          }
          return '';
        })}
      </div>
    );
  }
}

const mapDispatchToProps = {
  updateSuggestionResults: (suggestions) => actions.updateSuggestionResults(suggestions),
  cancelSearch: () => actions.cancelAddressSearch(),
};

const mapStateToProps = (state) => ({
  ...state.indexpage,
  realEstateType: getRealEstateType(state),
  userIntent: getUserIntent(state),
});

AddressSearchResults.propTypes = {
  userIntent: PropTypes.string.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressSearchResults);
